import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const DAY_NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function SettingsTab({ settings, reload }) {
  const [workingDays, setWorkingDays] = useState(settings.working_days);
  const [blocked, setBlocked] = useState(settings.blocked_dates);
  const [newBlock, setNewBlock] = useState("");
  const [saving, setSaving] = useState(false);

  const toggleDay = (d) =>
    setWorkingDays((cur) => (cur.includes(d) ? cur.filter((x) => x !== d) : [...cur, d].sort()));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", { working_days: workingDays, blocked_dates: blocked });
      toast.success("Availability saved");
      reload();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  const box = "p-5 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/20";

  return (
    <div className="space-y-6" data-testid="settings-tab">
      <div className={box}>
        <h3 className="font-display uppercase text-lg text-white mb-4">Working Days</h3>
        <div className="flex flex-wrap gap-2">
          {DAY_NAMES.map((name, i) => (
            <button key={name} onClick={() => toggleDay(i)} data-testid={`working-day-${name.toLowerCase()}`}
              className={`px-4 py-2 rounded-xl border text-xs font-mono-lbl uppercase transition-colors ${
                workingDays.includes(i)
                  ? "border-[#1e9bff] bg-[#1e9bff]/15 text-white"
                  : "border-white/15 text-[#627d98] hover:border-[#1e9bff]/50"
              }`}>
              {name}
            </button>
          ))}
        </div>
      </div>

      <div className={box}>
        <h3 className="font-display uppercase text-lg text-white mb-4">Blocked Dates</h3>
        <div className="flex flex-wrap gap-2 mb-4">
          <input type="date" value={newBlock} onChange={(e) => setNewBlock(e.target.value)} data-testid="blocked-date-input"
            className="bg-[#070b12] border border-white/15 rounded-lg px-3 py-2 text-xs text-white [color-scheme:dark]" />
          <button
            onClick={() => { if (newBlock && !blocked.includes(newBlock)) { setBlocked([...blocked, newBlock].sort()); setNewBlock(""); } }}
            data-testid="blocked-date-add-btn"
            className="px-4 py-2 rounded-lg bg-[#1e9bff]/15 border border-[#1e9bff]/40 text-[#1e9bff] text-xs font-mono-lbl uppercase hover:bg-[#1e9bff]/25 transition-colors">
            Block Date
          </button>
        </div>
        <div className="flex flex-wrap gap-2" data-testid="blocked-dates-list">
          {blocked.length === 0 && <span className="text-xs text-[#627d98]">No blocked dates.</span>}
          {blocked.map((d) => (
            <span key={d} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-500/10 border border-red-500/30 text-red-300 text-xs font-mono-lbl">
              {d}
              <button onClick={() => setBlocked(blocked.filter((x) => x !== d))} data-testid={`blocked-date-remove-${d}`} className="hover:text-white">×</button>
            </span>
          ))}
        </div>
      </div>

      <button onClick={save} disabled={saving} data-testid="settings-save-btn"
        className="w-full py-4 rounded-xl bg-[#1e9bff] text-black font-display uppercase tracking-wider hover:bg-[#60baff] transition-colors disabled:opacity-50">
        {saving ? "Saving…" : "Save Availability"}
      </button>
    </div>
  );
}
